var filterEmptyTextContent = function filterEmptyTextContent(content) {
  var _content$props, _content$props2;

  return content !== null && content !== void 0 && (_content$props = content.props) !== null && _content$props !== void 0 && _content$props.children && !Array.isArray(content.props.children) ? filterEmptyTextContent(content.props.children) : !!(Array.isArray(content === null || content === void 0 ? void 0 : (_content$props2 = content.props) === null || _content$props2 === void 0 ? void 0 : _content$props2.children) && content.props.children.join('').trim().replace(/(^,)|(,$)/g, ''));
};

export var removeEmptyTextContent = function removeEmptyTextContent(text) {
  return text.filter(filterEmptyTextContent);
};
export default {
  removeEmptyTextContent: removeEmptyTextContent
};
//# sourceMappingURL=utils.js.map